import Button from 'core/components/buttons/Button'
import notFoundIllustration from 'assets/images/404.png'
import useNavigation from 'core/hooks/useNavigation'
import { DashboardUrl } from 'constants/RouteUrls'

const NotFoundPage = () => {
  const { replace } = useNavigation()
  return (
    <div className="flex flex-col items-center text-center gap-12 mt-10">
      <div>
        <img
          src={notFoundIllustration}
          alt="Not found illustration"
          className="w-56"
        />
      </div>
      <h1 className="text-4xl font-bold">404 - Page not found</h1>
      <div>
        <h4>We couldn't find the page you are looking for.</h4>
        <h4>
          Need more help?{' '}
          <a
            href="https://www.everlance.com/contact-us"
            rel="no-referrer"
            className="text-lg text-primary-3 hover:underline"
          >
            Contact support.
          </a>
        </h4>
      </div>
      <Button
        variant="primary"
        onClick={() => {
          replace(DashboardUrl)
        }}
      >
        Back to home
      </Button>
    </div>
  )
}

export default NotFoundPage
